import { render, staticRenderFns } from "./tan_needGz_sin.vue?vue&type=template&id=e9fb18e4&scoped=true"
import script from "./tan_needGz_sin.vue?vue&type=script&lang=js"
export * from "./tan_needGz_sin.vue?vue&type=script&lang=js"
import style0 from "./tan_needGz_sin.vue?vue&type=style&index=0&id=e9fb18e4&prod&lang=css"
import style1 from "./tan_needGz_sin.vue?vue&type=style&index=1&id=e9fb18e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9fb18e4",
  null
  
)

export default component.exports